import { render, staticRenderFns } from "./studentEditImport.vue?vue&type=template&id=44d7afe6"
import script from "./studentEditImport.vue?vue&type=script&lang=js"
export * from "./studentEditImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports